import ReactDOM from 'react-dom';
import React, { memo, useEffect, useState } from 'react';
import Text from 'components/Text';

import {
  ArrowLeft,
  ToolTipMessage,
  ToolTipContainer
} from './components/Styled';

const Root = document.getElementById('root-top');

export const ToolTip = memo(({
  message = 'Tooltip',
  children
}) => {
  var timerId;
  var mousePos;

  const [ isShowing, showMessage ] = useState(false);
  const [ position, setPosition ] = useState(false);

  const clearTimer = () => {
    showMessage(false);
    clearInterval(timerId);
    timerId = null;
  };

  const onMouseMove = (e) => {
    mousePos = { x: e.pageX, y: e.pageY };
  };

  const setTimer = (e) => {
    window.addEventListener('mousedown', clearTimer, { once: true });
    clearInterval(timerId);

    timerId = setTimeout(() => {
      clearTimer();

      if (!mousePos || !mousePos.x || !mousePos.y) {
        isShowing && showMessage(false);
        return;
      }

      setPosition(() => ({ x: mousePos.x, y: mousePos.y }));
      showMessage(() => true);
    }, 250);
  };

  return (
    <ToolTipContainer onMouseMove={onMouseMove} position={position} onMouseOut={clearTimer} onMouseOver={setTimer}>
      <Message position={position} message={message} isShowing={isShowing} />
      <React.Fragment>{ children }</React.Fragment>
    </ToolTipContainer>
  );
});

export default ToolTip;

export const MessagePopIn = memo(({
  hide,
  delay,
  children,
  onComplete,
  message = 'Tooltip'
}) => {
  if (hide) return children;

  var timerId;
  var startTimer;

  const [ isShowing, showMessage ] = useState(!delay);

  useEffect(() => {
    startTimer = setTimeout(() => {
      clearInterval(startTimer);
      showMessage(true);
      setTimer();
    }, delay);

    if (!delay) {
      setTimer();
    }

    return () => {
      clearTimer(timerId);
      clearTimer(startTimer);
    };
  }, []);

  const clearTimer = () => {
    showMessage(false);
    clearInterval(timerId);
    timerId = null;
  };

  const setTimer = (e) => {
    window.addEventListener('mousedown', clearTimer, { once: true });
    clearInterval(timerId);

    timerId = setTimeout(() => {
      clearTimer();
      showMessage(() => false);
      onComplete && onComplete();
    }, 2500
    );
  };

  return (
    <ToolTipContainer>
      <Message inline message={message} isShowing={isShowing} />
      <React.Fragment>{ children }</React.Fragment>
    </ToolTipContainer>
  );
});

const Message = props => !props.inline
  ? ReactDOM.createPortal(<MessageDisplay {...props} />, Root)
  : <MessageDisplay {...props} />;

const MessageDisplay = ({ inline, position, isShowing, message }) => isShowing ? (
  <ToolTipMessage inline={inline} position={position} isShowing={isShowing}>
    <ArrowLeft />
    <Text.Default color={'#fff'}>{message}</Text.Default>
  </ToolTipMessage>
) : null;
